<template>
  <DrawerClose data-slot="drawer-close" v-bind="props">
    <slot />
  </DrawerClose>
</template>

<script setup>
import { DrawerClose } from 'reka-ui';

const props = defineProps({
  asChild: { default: undefined, type: Boolean, required: false },
  as: { default: undefined, type: null, required: false },
});
</script>
